import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1 pt-16 flex items-center justify-center">
        <div className="text-center px-4">
          <div className="w-24 h-24 mx-auto mb-6 flex items-center justify-center rounded-full bg-background-200/60">
            <i className="ri-error-warning-line text-4xl text-foreground-400"></i>
          </div>
          <h1 className="text-4xl md:text-6xl font-heading font-bold text-foreground-950 mb-3">404</h1>
          <p className="text-lg text-foreground-500 mb-8">抱歉，您访问的页面不存在。</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i>
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}